import { getFields, reqCreateData, reqGetData } from "../../fn/req";
import store from "../../redux/store";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import { dataFilter, getTabs, getItem, updateData } from "../../fn/data";
import { setAlert, setItem } from "../../redux/actions/menu";
import { Redirect } from "react-router";

const { Grid, Typography, Dialog, DialogContent, DialogTitle } = require("@material-ui/core");
const { Component } = require("react");
const { default: TableShow } = require("../data/dataShow/table");
const { default: Header } = require("../Menu/Header");
const { default: Search } = require("../Search");
const { default: Actions } = require("../Menu/Actions");
const { default: Inputs } = require("../data/dataInput/inputs");

class Jobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: [],
      form: {},
      filteredJobs: [],
      searchedValue: null,
      redirect: false,
      fields: [],
      modal: {
        open: false,
      },
      redirectTo: "",
    };
  }

  componentDidMount() {
    reqGetData({ target: "jobs" }, cb => {
      this.setState({ jobs: cb });
    });

    getFields({ target: "jobs", tab: "overview" }, cb =>
      cb ? this.setState({ fields: cb.fields, allowDelete: cb.allowDelete }) : null
    );

    this.unsubscribe = store.subscribe(() => {
      let state = store.getState();
      let searchedValue = state.menu.filter ? state.menu.filter.searchedValue : null;
      if (searchedValue && searchedValue !== this.state.searchedValue) {
        dataFilter({ data: this.state.jobs, filter: searchedValue }, cb => {
          this.setState({ searchedValue, filteredJobs: cb });
        });
      }

      if (!searchedValue) {
        this.setState({ searchedValue });
      }
    });
  }

  handleAction(opt) {
    let type = opt.type;
    switch (type) {
      case "view":
        store.dispatch(
          setItem({
            tab: 2,
            type: "view",
            titleFields: ["jobName"],
            data: getItem({ data: this.state.jobs, id: opt.id }),
            origin: "jobs",
            tabs: getTabs({ target: "jobs" }),
          })
        );
        this.setState({
          redirect: true,
          redirectTo: "/item",
        });
        break;
      case "delete":
        this.setState({
          modal: {
            open: true,
            text: "Are you sure?",
            title: "Delete job",
            actions: [
              {
                value: "close",
                alias: "Close",
                action: () => this.setState({ modal: { open: false } }),
                color: "secondary",
                startIcon: <CloseIcon />,
              },
              {
                value: "delete",
                alias: "YES",
                action: () =>
                  this.deleteItem({
                    id: opt.id,
                    target: "jobs",
                  }),
                color: "secondary",
                startIcon: <DeleteIcon />,
              },
            ],
          },
        });
        break;
      default:
        break;
    }
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  deleteItem = opt => {
    updateData(
      {
        target: opt.target,
        id: opt.id,
        data: { itemState: false },
      },
      cb => {
        if (cb) {
          this.setState({ jobs: cb, modal: { open: false } });
          store.dispatch(
            setAlert({
              text: "Item deleted",
              open: true,
              timeout: 2000,
              severity: "success",
            })
          );
        } else {
          // not able to delete
          this.setState({ modal: { open: false } });
          store.dispatch(
            setAlert({
              text: "Not able to delete item",
              open: true,
              timeout: 2000,
              severity: "error",
            })
          );
        }
      }
    );
  };

  saveData(opt) {
    reqCreateData({ target: "jobs", data: this.state.form }, cb => {
      if (cb) {
        // update jobs
        reqGetData({ target: "jobs" }, cb => {
          this.setState({ jobs: cb, modal: { open: false }, form: {} });
        });
      } else {
        // not update // alert job
        store.dispatch(
          setAlert({
            text: "Not able to add jobs",
            open: true,
            timeout: 2000,
            severity: "error",
          })
        );
      }
    });
  }

  handleChange(opt) {
    let form = { ...this.state.form };
    form[opt.target] = opt.value;
    this.setState({ form });
  }

  mainComp = opt => {
    let data = opt.data;

    return (
      <Grid container>
        <Header tab={1} />
        <Grid container item>
          <Grid item xs={12} md={6} lg={6} className='my-3'>
            <Typography align='center' variant='h4' className='text-Pmain'>
              {"Jobs List"}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} lg={3} className='my-3'>
            <Search />
          </Grid>
        </Grid>
        <Grid xs={12} item>
          <TableShow
            tableProps={{ size: "small" }}
            heads={this.state.tableHeads}
            headFilters
            allowDelete={this.state.allowDelete}
            lines={data ? data : []}
          />
        </Grid>
      </Grid>
    );
  };

  render() {
    let filter = this.state.searchedValue;
    let modal = this.state.modal;
    if (this.state.redirect) {
      return <Redirect to={this.state.redirectTo} />;
    } else {
      var fields = [...this.state.fields];
      fields.push({
        value: "actions",
        alias: "Actions",
        type: "actions",
        variants: [
          {
            value: "view",
            alias: "View",
            icon: "visibility",
            action: opt => this.handleAction({ id: opt, type: "view" }),
          },
          {
            value: "delete",
            alias: "delete",
            icon: "delete",
            action: opt => this.handleAction({ id: opt, type: "delete" }),
          },
        ],
      });

      return (
        <Grid container>
          <Header tab={2} />
          <Grid container item>
            <Grid item xs={12} md={6} lg={6} className='my-3'>
              <Typography variant='h4' align='center' className='my-3 text-Pmain'>
                {"Jobs List"}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={3} className='my-3'>
              <Search />
            </Grid>
          </Grid>
          <Grid xs={12} item>
            <TableShow
              tableProps={{ size: "small" }}
              heads={fields}
              headFilters
              lines={filter ? this.state.filteredJobs : this.state.jobs}
            />
          </Grid>
          <Dialog
            open={modal.open}
            onClose={() => this.setState({ modal: { open: false } })}
            fullWidth={true}
            maxWidth={"md"}
          >
            <DialogTitle>{modal.title}</DialogTitle>
            {modal.text ? (
              <Typography variant='h4' align='center'>
                {modal.text}
              </Typography>
            ) : null}

            <DialogContent>
              <Inputs
                inputs={modal.inputs}
                values={this.state.form}
                handleChange={this.handleChange.bind(this)}
              />
            </DialogContent>
            <Grid className='m-2'>
              <Actions actions={modal.actions} />
            </Grid>
          </Dialog>
        </Grid>
      );
    }
  }
}

export default Jobs;
